export default __webpack_public_path__ + "assets/images/57c52b5dd5566867f4ee4229d1f0b5a7.svg";